import { createFileRoute } from '@tanstack/react-router';
import CompanyUsersView from '../admin/company-users/view';
export const Route = createFileRoute('/admin/users/')({ component: CompanyUsersView });
